import React from 'react'
import Footer from '../Footer'
import Header from '../Header'
import ProfileEdit from '../Profile/ProfileEdit'

const ProfilePage = () => {
  return (
    <>
    
        <Header/>
        <ProfileEdit/>
        <Footer/>

    </>
  )
}

export default ProfilePage
